import { Component, OnInit, Inject, AfterViewInit, Input } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators, FormBuilder, FormArray, FormGroup } from '@angular/forms';
import * as  _ from 'lodash';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { OrderService } from '@app/_services';
import { ToastrService } from 'ngx-toastr';
import { TranslateHelper } from '@app/_helpers';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { NgIf, DatePipe } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
    selector: 'app-cancel-professional-order-information',
    templateUrl: './cancel-order-information.component.html',
    styleUrls: ['./cancel-order-information.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [MatExpansionModule, NgIf, DatePipe, TranslateModule]
})
export class CancelProfessionalOrderInformationComponent {

    constructor(public translate: TranslateService, public translateHelper: TranslateHelper) { }


    @Input() cancelData;

}
